import React from 'react';

/**
 * StepCard Component
 * Displays the walkthrough step content in a centered card
 */
const StepCard = ({ step, stepIndex, totalSteps, onClose }) => {
  if (!step) return null;

  const handleCardClick = (e) => {
    // Prevent clicks inside the card from closing the modal
    e.stopPropagation();
  };

  return (
    <div 
      className={`walkthrough-step-card ${step.isWelcome ? 'walkthrough-step-card-welcome' : ''}`}
      onClick={handleCardClick}
      role="dialog"
      aria-labelledby="walkthrough-title"
      aria-describedby="walkthrough-description"
      aria-modal="true"
    >
      {/* Progress Indicator */}
      <div className="walkthrough-progress" aria-label={`Step ${stepIndex + 1} of ${totalSteps}`}>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`walkthrough-progress-dot ${index === stepIndex ? 'active' : ''}`}
            aria-current={index === stepIndex ? 'step' : undefined}
          />
        ))}
      </div>

      {/* Content */}
      <div className="walkthrough-step-card-content">
        <h2 
          id="walkthrough-title"
          className="walkthrough-step-card-title"
        >
          {step.content.title}
        </h2>
        <p 
          id="walkthrough-description"
          className="walkthrough-step-card-description"
        >
          {step.content.description}
        </p>
        {step.content.signature && (
          <p className="walkthrough-step-card-signature">
            {step.content.signature}
          </p>
        )}
      </div>
    </div>
  );
};

export default StepCard;
